import Dialog from '@jetbrains/ring-ui/components/dialog/dialog'
import {H1} from '@jetbrains/ring-ui/components/heading/heading'
import {Content} from '@jetbrains/ring-ui/components/island/island'
import Panel from '@jetbrains/ring-ui/components/panel/panel'
import * as React from 'react'

import type {DialogProps} from '../../../../../hocs/withDialogContainer'
import withDialogContainer from '../../../../../hocs/withDialogContainer'
import {DialogType} from '../../../../../types'

import {AgentPoolsFavoriteListContainer} from './AgentPoolsFavoriteDialogList'

import styles from './AgentPoolsFavoriteDialog.css'

interface Props {
  id: string
  searchQuery?: string
}

function AgentPoolsFavoriteDialogContent(props: {searchQuery?: string}) {
  const {searchQuery} = props
  return (
    <Content
      fade={false}
      className={styles.content}
      scrollableWrapperClassName={styles.scrollableWrapper}
    >
      <>
        <div>
          <H1 className={styles.header}>{'Configure Favorites Agent Pools'}</H1>
          <div className={styles.shortcuts}>
            {'Toggle favorites: Enter'}
            <br />
            {'Move: ↑↓'}
          </div>
        </div>
        <AgentPoolsFavoriteListContainer searchQuery={searchQuery} />
        <Panel className={styles.footer}>{'Changes are applied automatically'}</Panel>
      </>
    </Content>
  )
}

export function AgentPoolsFavoriteDialogComponent({
  isOpened,
  closeDialog,
  searchQuery,
}: DialogProps<Props>) {
  return (
    <Dialog
      label="Configure Favorites Agent Pools"
      show={isOpened}
      onCloseAttempt={closeDialog}
      contentClassName={styles.dialog}
      showCloseButton
    >
      <AgentPoolsFavoriteDialogContent searchQuery={searchQuery} />
    </Dialog>
  )
}

export const AgentPoolsFavoriteDialog = withDialogContainer<Props>(
  DialogType.FAVORITE_AGENT_POOLS,
  (_, props) => props.id,
)(AgentPoolsFavoriteDialogComponent)
